import * as Yup from 'yup'
import Tr from 'translations/Translations';
import {CRYTERIUM_TYPE as CRYTERIUM_VARIANT, CRYTERIUM_TYPE_LABEL} from './criterium.type'
import {VARIANT_CODE as CRITERIA_TYPE} from './criteria.variants'
import {VARIANT_CODE as CRITERIA_ELEMENT_TYPE} from './criteriaElement.variants'
import {VALUES as TABS} from './tabs.values'
import VS from 'constants/ValidationShema'
import InputLimits from 'constants/InputLimits';
import toFloat from 'libs/toFloat';

export default (selectedItems) => Yup.lazy(values => {

    const weight =  values.weight ? parseFloat(parseFloat(values.weight).toFixed(2)) : 0;

    const min0MaxWeight = VS.numberMaxMin(0, weight, null, 'v_number_max_weight', Tr('points'));

    const from = VS.decimalNumber(Tr("from"))
    const to = VS.decimalNumber(Tr("to"))

    const reg = '^(?!(' + selectedItems.map(x => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')$).*$';
    const otherNameRegExp = new RegExp(reg)
    let shape = {
        otherName: (values.type === CRYTERIUM_VARIANT.OTHER || values.type === CRYTERIUM_VARIANT.PRICE) ?
            VS.stringExactlyMax(
                otherNameRegExp,
                Tr('v_criteria_exist'),
                InputLimits.procedure.criteriaSection.NAME
            ) : VS.any(),
        isSelected: values.tab === TABS.NEW ?
            VS.any() :
            VS.immediatelyError(Tr('new_criteria_popup_v_choose')),
        weight: VS.numberMax(100)
    }
    switch (values.type) {
        case CRYTERIUM_VARIANT.OTHER:
        case CRYTERIUM_VARIANT.PRICE:
            //to jest walidowane przy pomocy otherName
            break;
        default:
            shape['type'] = VS.string().test(
                'duplicate',
                Tr('v_criteria_exist'),
                (formValue) => {
                    return otherNameRegExp.test(CRYTERIUM_TYPE_LABEL[formValue]);
                }
            )
    }

    switch (values.uiType) {
        case CRITERIA_TYPE.LIST:

            shape['valuesList'] = VS.lazy(list => {
                let keys = [];
                let errorKeys = [];

                const maxListPoints = Math.max(...list.map(o => o.value), 0);
                let pointsLessThanWeight = maxListPoints === weight;

                list.forEach((x, i, arr) => {
                    if (keys.indexOf(x.key) === -1) {
                        keys.push(x.key);
                    } else {
                        errorKeys.push(x.key);
                    }
                });
                return VS.arrayOf(VS.lazy((x, y, z) => {

                    return VS.object({
                        value: min0MaxWeight,
                        key: VS.stringMax(1000)
                            .test(
                                'duplicate',
                                Tr('v_keys_must_be_unique'),
                                (formValue) => {
                                    return errorKeys.indexOf(formValue) === -1;
                                }
                            )
                    })
                })).min(2, Tr('at_least_two_values'))
                    .test('weight_less_than_points', Tr('v_number_weight_less_than_points'), () => pointsLessThanWeight)
            });

            break;
        case CRITERIA_TYPE.INTERVAL:
            shape['intervalList'] = VS.lazy(list => {

                const maxListPoints = Math.max(...list.map(o => o.value), 0);
                const pointsLessThanWeight = maxListPoints === weight;

                let validation = {};

                list.forEach((x, i) => {
                    let curRowValidation = {};
                    validation[x.id] = curRowValidation;

                    if (x.type === CRITERIA_ELEMENT_TYPE.SMALLER && i !== 0) {
                        curRowValidation.smallerError = true;
                    }

                    if (x.type === CRITERIA_ELEMENT_TYPE.BIGGER && i !== (list.length - 1)) {
                        curRowValidation.biggerError = true;
                    }

                    if (x.type === CRITERIA_ELEMENT_TYPE.RANGE) {

                        curRowValidation.rangeSameError = x.from === x.to ? !x.fromInclusive || !x.toInclusive : false;
                    }

                    if (i !== 0) {
                        const curFrom = toFloat(x.from);
                        const prevTo = toFloat(list[i - 1].to);
                        if (curFrom !== prevTo) {
                            curRowValidation.inservalStartToPrevEndError = true;
                        }
                        if (x.type === CRITERIA_ELEMENT_TYPE.RANGE) {
                            const curTo = toFloat(x.to);
                            if (curTo < curFrom) {
                                curRowValidation.inservalStartLesThanEndError = true;
                            }
                        }
                    }
                })

                return VS.arrayOf(VS.lazy(x => {
                    const elementErrors = validation[x.id];
                    switch (x.type) {
                        case CRITERIA_ELEMENT_TYPE.RANGE:
                            return VS.object({
                                value: min0MaxWeight,
                                to,
                                from: from
                                    .test(
                                        'lessPrev',
                                        Tr('v_interval_contained_within'),
                                        (formValue) => {
                                            return !elementErrors.inservalStartToPrevEndError;
                                        })
                                    .test(
                                        'less',
                                        Tr('v_number_less_than', {from: Tr('from'), to: Tr('to')}),
                                        (fromValue) => {
                                            return !elementErrors.inservalStartLesThanEndError
                                        }).test(
                                        'rangeSameError',
                                        Tr('v_interval_contained_within'),
                                        (fromValue) => {
                                            return !elementErrors.rangeSameError;
                                        }
                                    ),
                            })

                        case CRITERIA_ELEMENT_TYPE.SMALLER:
                            return VS.object({
                                value: min0MaxWeight,
                                to: to
                                    .test(
                                        'smallerFirst',
                                        Tr('v_smaller_not_first'),
                                        (formValue) => {
                                            return !elementErrors.smallerError;
                                        }
                                    ),
                            })

                        case CRITERIA_ELEMENT_TYPE.BIGGER:
                        default:
                            return VS.object({
                                value: min0MaxWeight,
                                from: from
                                    .test(
                                        'biggerLast',
                                        Tr('v_bigger_not_last'),
                                        (formValue) => {
                                            return !elementErrors.biggerError;
                                        }
                                    )
                                    .test(
                                        'lessPrev',
                                        Tr('v_interval_contained_within'),
                                        (formValue) => {
                                            return !elementErrors.inservalStartToPrevEndError;
                                        }),
                            })
                    }
                })).min(1, Tr('mustNotBeEmpty', {value: Tr('values')})).test('weight_less_than_points', Tr('v_number_weight_less_than_points'), () => pointsLessThanWeight)
            })

            break;
        case CRITERIA_TYPE.NUMBER:
        case CRITERIA_TYPE.PRICE:
            shape['direction'] = VS.string();
            break;
        case CRITERIA_TYPE.TEXT:
        case CRITERIA_TYPE.YESNO:
        default:
            break;
    }

    return VS.object(shape)
})